import { render, staticRenderFns } from "./hubTwoThree.vue?vue&type=template&id=7cf07938&scoped=true"
import script from "./hubTwoThree.vue?vue&type=script&lang=js"
export * from "./hubTwoThree.vue?vue&type=script&lang=js"
import style0 from "./hubTwoThree.vue?vue&type=style&index=0&id=7cf07938&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf07938",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cf07938')) {
      api.createRecord('7cf07938', component.options)
    } else {
      api.reload('7cf07938', component.options)
    }
    module.hot.accept("./hubTwoThree.vue?vue&type=template&id=7cf07938&scoped=true", function () {
      api.rerender('7cf07938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/lossRateStats/component/hubTwoThree.vue"
export default component.exports